<template>
  <v-card class="pa-4 mb-4">
    <v-card-title>Analisi per giorno e fascia oraria</v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="4">
          <v-data-table
              :headers="hourHeaders"
              :items="hourTable"
              hide-default-footer
              dense
              class="elevation-1 mb-4"
              :items-per-page="1000"
              style="overflow-y: auto; max-height: 600px; padding: 0;"
          />
          <v-data-table
              :headers="dayHeaders"
              :items="dayTable"
              hide-default-footer
              dense
              class="elevation-1"

          />
        </v-col>
        <v-col cols="12" md="8" style="max-height: 800px; overflow-y: scroll">
          <apexchart
              type="heatmap"
              :height="dynamicChartHeight"
              :options="heatmapOptions"
              :series="heatmapSeries"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

const WEEKDAYS = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica'];

export default {
  name: 'ChartReservationBySlotAndWeekday',
  components: { apexchart: VueApexCharts },
  props: {
    filters: Object
  },
  data() {
    return {
      result: null,
      hourTable: [],
      dayTable: [],
      heatmapSeries: [],
      hourHeaders: [
        { text: 'Fascia oraria', value: 'hour' },
        { text: 'Totale', value: 'total', align: 'right' }
      ],
      dayHeaders: [
        { text: 'Giorno', value: 'day' },
        { text: 'Totale', value: 'total', align: 'right' }
      ],
      heatmapOptions: {
        chart: {
          type: 'heatmap'
        },
        dataLabels: {
          enabled: true
        },
        xaxis: {
          type: 'category',
          categories: WEEKDAYS
        },
        yaxis: {
          labels: {
            style: {
              fontSize: '10px'
            }
          }
        },
        plotOptions: {
          heatmap: {
            shadeIntensity: 0.5,
            colorScale: {
              ranges: [
                // { from: 0, to: 0, color: '#959595', name: 'nd' },
                // { from: 0.1, to: 5, color: '#007a8f', name: 'Basso' },
                // { from: 6, to: 15, color: '#4DD0E1', name: 'Medio' },
                // { from: 16, to: 1000, color: '#8cff24', name: 'Alto' }
              ]
            }
          }
        }
      }
    };
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler(newFilters) {
        this.fetchData(newFilters);
      }
    }
  },
  methods: {
    async fetchData(filters) {
      const data = await this.$store.dispatch('analytics/getReservationBySlotAndWeekday', filters);
      this.result = data;

      this.hourTable = data.byHour.map(r => ({
        hour: r._id,
        total: r.total
      }));

      this.dayTable = data.byWeekday.map(r => ({
        day: WEEKDAYS[(r._id - 1 + 7) % 7], // convert 1=Mon...7=Sun
        total: r.total
      }));

      // build heatmap: hour => [ { name, data: [count per weekday] } ]
      const matrix = {};
      for (const entry of data.matrix || []) {
        const slot = entry.slot_range;
        const weekday = entry.weekday - 1; // 0-based
        if (!matrix[slot]) matrix[slot] = new Array(7).fill(0);
        matrix[slot][weekday] = entry.total;
      }

      const values = [];
      const sortedSlots = Object.keys(matrix || {}).sort(this.sortSlots);

      this.heatmapSeries = sortedSlots.map(slot => {
        return {
          name: slot,
          data: matrix[slot].map((val, index) => {
            values.push(val);
            return { x: WEEKDAYS[index], y: val };
          })
        };
      });

      this.heatmapOptions.plotOptions.heatmap.colorScale.ranges = this.getColorScaleRanges(values);

    },
    sortSlots(a, b) {
      const parseStartHour = slot => {
        const [hour, minute] = slot.split('-')[0].split(':').map(Number);
        return hour * 60 + minute;
      };
      return parseStartHour(b) - parseStartHour(a);
    },
    getColorScaleRanges(values) {
      const max = Math.max(...values);
      const step = Math.ceil(max / 2);

      return [
        { from: 0, to: 0, color: '#959595', name: 'nd' },
        { from: 0.1, to: step, color: '#007a8f', name: 'Basso' },
        { from: step + 1, to: step * 2, color: '#4DD0E1', name: 'Medio' },
        { from: step * 2 + 1, to: max, color: '#006064', name: 'Alto' }
      ];
    }

  },
  computed: {
    dynamicChartHeight() {
      const rows = this.heatmapSeries.length;
      const rowHeight = 40; // pixel per riga, puoi regolarlo
      const padding = 50; // per label/legend/margini
      return rows * rowHeight + padding;
    }
  }
};
</script>
